import * as React from "react";

const SVGComponent = (
  props
) => (
  <svg
    width="74"
    height="55"
    viewBox="0 0 74 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      y="19.7207"
      width="9.05587"
      height="18.8944"
      rx="4.52794"
      fill="white"
    />
    <rect
      x="64.8438"
      y="18.938"
      width="9.05587"
      height="18.8944"
      rx="4.52794"
      fill="white"
    />
    <rect
      x="25.9375"
      y="19.7212"
      width="9.05587"
      height="27.1676"
      rx="4.52794"
      fill="white"
    />
    <rect
      x="38.9082"
      y="2.05615"
      width="9.05587"
      height="35.7763"
      rx="4.52794"
      fill="white"
    />
    <rect
      x="12.9688"
      y="21.0664"
      width="9.05227"
      height="32.2261"
      rx="4.52613"
      fill="white"
    />
    <rect
      x="13.0352"
      y="10.665"
      width="9.05227"
      height="9.05227"
      rx="4.52613"
      fill="white"
    />
    <rect
      x="51.7109"
      y="21.1655"
      width="9.05227"
      height="32.2261"
      rx="4.52613"
      fill="white"
    />
    <rect
      x="51.7773"
      y="10.665"
      width="9.05227"
      height="9.05227"
      rx="4.52613"
      fill="white"
    />
  </svg>
);

export default SVGComponent;
